import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { RouterProvider } from './lib/router';
import './styles.css';
import './workspace.css';
import { withConsoleBase } from './config';
import { finishGoogleMailConnection } from './lib/google-mail';

const root = document.getElementById('root');
if (!root) throw new Error('Missing console root');

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false } } });
if (window.location.pathname === withConsoleBase('/mail/google/callback')) {
  void finishGoogleMailConnection(root);
} else {
  ReactDOM.createRoot(root).render(<React.StrictMode><QueryClientProvider client={queryClient}><RouterProvider><AuthProvider><App /></AuthProvider></RouterProvider></QueryClientProvider></React.StrictMode>);
}
